import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { toast } from 'sonner';

const MOODS = [
    { score: 1, label: 'Tungt', color: 'bg-crisis', ring: 'ring-crisis' },
    { score: 2, label: 'Dårlig', color: 'bg-[#E5A779]', ring: 'ring-[#E5A779]' },
    { score: 3, label: 'Ok', color: 'bg-[#E8D9A0]', ring: 'ring-[#E8D9A0]' },
    { score: 4, label: 'Bra', color: 'bg-[#A7C1A8]', ring: 'ring-[#A7C1A8]' },
    { score: 5, label: 'Veldig bra', color: 'bg-sage', ring: 'ring-sage' },
];

export default function Mood() {
    const [moods, setMoods] = useState([]);
    const [score, setScore] = useState(3);
    const [note, setNote] = useState('');
    const [saving, setSaving] = useState(false);

    const load = () => api.get('/mood').then(r => setMoods(r.data));
    useEffect(() => { load(); }, []);

    const save = async () => {
        setSaving(true);
        try {
            await api.post('/mood', { score, note });
            setNote('');
            toast.success('Lagret');
            load();
        } catch { toast.error('Kunne ikke lagre'); }
        finally { setSaving(false); }
    };

    return (
        <div className="max-w-3xl mx-auto px-6 py-10 pb-24" data-testid="mood-page">
            <h1 className="font-display text-3xl font-bold tracking-tight">Hvordan er det med deg?</h1>
            <p className="mt-2 text-inkSoft">Ett trykk er nok. Notat er valgfritt.</p>

            <div className="mt-8 rounded-2xl border border-sand bg-white p-6">
                <div className="flex flex-wrap gap-4 justify-between" data-testid="mood-buttons">
                    {MOODS.map(m => (
                        <button
                            key={m.score}
                            onClick={() => setScore(m.score)}
                            data-testid={`mood-${m.score}`}
                            className={`flex flex-col items-center gap-2 transition-transform hover:scale-105`}
                        >
                            <span className={`w-14 h-14 rounded-full ${m.color} ${score === m.score ? `ring-4 ring-offset-2 ring-offset-bone ${m.ring}/40` : ''} transition-all`} />
                            <span className="text-xs text-inkSoft">{m.label}</span>
                        </button>
                    ))}
                </div>
                <Textarea
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    placeholder="Vil du si noe om hvorfor? (valgfritt)"
                    className="mt-6 bg-white border-sand rounded-xl min-h-[80px]"
                    data-testid="mood-note"
                />
                <Button onClick={save} disabled={saving} className="mt-4 rounded-full bg-sage hover:bg-sage-dark text-bone" data-testid="mood-save-btn">
                    {saving ? 'Lagrer…' : 'Logg humør'}
                </Button>
            </div>

            <h2 className="font-display text-xl font-semibold mt-12">Tidligere</h2>
            <div className="mt-4 space-y-2">
                {moods.length === 0 && <p className="text-sm text-inkSoft">Ingen oppføringer ennå.</p>}
                {moods.map(m => {
                    const meta = MOODS.find(x => x.score === m.score);
                    return (
                        <div key={m.mood_id} className="flex items-start gap-3 p-3 rounded-xl border border-sand bg-white" data-testid={`mood-entry-${m.mood_id}`}>
                            <span className={`w-6 h-6 rounded-full ${meta?.color} shrink-0 mt-0.5`} />
                            <div className="flex-1 min-w-0">
                                <p className="text-sm text-ink"><span className="font-medium">{meta?.label}</span> · <span className="text-inkSoft">{new Date(m.created_at).toLocaleString('nb-NO')}</span></p>
                                {m.note && <p className="text-sm text-inkSoft mt-1 whitespace-pre-wrap">{m.note}</p>}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
